<template>
  <div class="ly-col ly-center-center reset-password-container">
    <img src="@/assets/img/lp-logo-white.svg" class="mb-3" />
    <div class="card">
      <h3>Your Session could not be refreshed</h3>
      <lp-button @click="closeWindow">Close this window</lp-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, inject } from 'vue'
import { useConfig } from '@/config/useConfig'

const postMessageToParentWindow = inject('postMessageToParentWindow') as (message: object, target: string) => void

const closeWindow = () => {
  window.close()
}

onMounted(async () => {
  const config = await useConfig()
  postMessageToParentWindow({ eventName: 'refreshFailed' }, config.sso.lms_url)
})

</script>

<style>
.form-reset-password {
  padding: 0px;
  margin: 0px;
}

.reset-password-container {
  height: 100%;
  background: #354255;
}

.reset-password-container .card {
  width: 550px;
}

.reset-password-container img {
  width: 200px;
}
</style>
